var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showError)?_c('gl-alert',{ref:"errorAlert",attrs:{"variant":"danger"},on:{"dismiss":_vm.hideError}},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('filter-sort-container'),_vm._v(" "),_c('members-table',{attrs:{"tab-query-param-value":_vm.tabQueryParamValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }